import { useLanguage } from "@/LanguageContext";
import { motion } from "framer-motion";

const COMPLICITE_IMG =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_senior-care-valais/artifacts/1710d4e4bf276daa_840621259_1416620683308690_3327328039874437323_n.jpg";
const RIRE_IMG =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_senior-care-valais/artifacts/b4a24bfb65c47003_843907731_2067353237253961_6558458767459654146_n.jpg";

const content = {
  fr: {
    label: "MOMENTS PARTAGÉS",
    title: "La vie continue, avec le sourire",
    subtitle: "De vrais instants, vécus lors de nos accompagnements.",
    compliciteAlt: "Une accompagnante et un monsieur âgé, souriants et complices, devant un chalet",
    compliciteCaption: "Un moment de complicité",
    rireAlt: "Une accompagnante et un monsieur âgé faisant une grimace complice lors d'une promenade",
    rireCaption: "Le rire, toujours",
  },
  de: {
    label: "GEMEINSAME MOMENTE",
    title: "Das Leben geht weiter – mit einem Lächeln",
    subtitle: "Echte Augenblicke aus unseren Begleitungen.",
    compliciteAlt: "Eine Begleiterin und ein älterer Herr lächeln gemeinsam vor einem Chalet",
    compliciteCaption: "Ein Moment der Verbundenheit",
    rireAlt: "Eine Begleiterin und ein älterer Herr albern bei einem Spaziergang herum",
    rireCaption: "Lachen gehört dazu",
  },
  en: {
    label: "SHARED MOMENTS",
    title: "Life goes on, with a smile",
    subtitle: "Real moments, shared during our visits.",
    compliciteAlt: "A companion and an elderly man smiling together in front of a chalet",
    compliciteCaption: "A moment of closeness",
    rireAlt: "A companion and an elderly man sharing a playful moment on a walk",
    rireCaption: "Always room for laughter",
  },
};

export default function MomentsSection() {
  const { language } = useLanguage();
  const t = content[language] || content.fr;

  return (
    <section
      data-testid="moments-section"
      className="py-24 lg:py-32 bg-[#F0EBE3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm font-body uppercase tracking-[0.2em] text-[#6FA8B6] mb-4">
            {t.label}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2C3E50]">
            {t.title}
          </h2>
          <p className="font-body text-base text-[#2C3E50]/60 mt-4 max-w-lg mx-auto">
            {t.subtitle}
          </p>
        </motion.div>

        <div className="max-w-[1040px] mx-auto grid grid-cols-1 md:grid-cols-[5fr_3fr] gap-8 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6 }}
          >
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img
                src={COMPLICITE_IMG}
                alt={t.compliciteAlt}
                loading="lazy"
                className="w-full h-auto object-cover"
              />
            </div>
            <p className="font-heading text-xl text-[#2C3E50] mt-4 text-center">
              {t.compliciteCaption}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img
                src={RIRE_IMG}
                alt={t.rireAlt}
                loading="lazy"
                className="w-full h-auto object-cover"
              />
            </div>
            <p className="font-heading text-xl text-[#2C3E50] mt-4 text-center">
              {t.rireCaption}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
